import { SubscriptionStatus } from '../context';

export const userIsFree = (subscriptionStatus: SubscriptionStatus | 'lifetime' | null) => {
  return !subscriptionStatus || subscriptionStatus === 'free';
};
